module.exports = __webpack_public_path__ + "img/horizontal_standart_footer.410ba9fc.svg";